/* eslint-disable jira/filename-case, jira/naming/disallow-filenames */
import { getProjectKeyId } from '@jira/router-resources__utils/src/getProjectKeyId.tsx';
// eslint-disable-next-line jira/restricted/@atlassian/react-resource-router
import { createResource, type RouteResource } from '@atlassian/react-resource-router';
import { fetchDefaultPINFiltersNavData } from '../../../services/sidebar/project-filters/main.tsx';
import type { DefaultPINFeatures as DefaultPinFeatures } from '../../../services/sidebar/project-filters/types.tsx';

export const staticSidebarDefaultPINFiltersResource: RouteResource<DefaultPinFeatures | null> =
	createResource<DefaultPinFeatures | null>({
		type: 'JIRA_PROJECT_DEFAULT_PIN_FILTERS_NAV_DATA',
		// oxlint-disable-next-line no-explicit-any
		getKey: ({ match, query }: { match: any; query: any }) => {
			const { projectKey } = getProjectKeyId(match, query);
			return projectKey || 'none';
		},
		getData: async ({ match, query }) => {
			const { projectKey } = getProjectKeyId(match, query);
			if (projectKey == null) {
				return null;
			}
			return fetchDefaultPINFiltersNavData(projectKey);
		},
		maxAge: 5 * 60 * 1000,
	});
